// extracted by mini-css-extract-plugin
export default {"circleBG":"Home_circleBG__na41t","squareBG":"Home_squareBG__-k2e5"};